import { Navigation } from '@sketch-note/design-system/src/shared/site-settings';
import { FullPageLoader } from '@sketchnote/shared-components';
import Router, { useRouter } from 'next/router';
import { useSession } from 'next-auth/client';
import { useEffect } from 'react';
import Analytics from 'src/api/services/analytics/analytics';
import { useAuth } from 'src/shared/hooks/use-auth';

export const withRoute = (Component) => {
  const Wrapper = () => {
    const [session, loading] = useSession();
    const router = useRouter();
    const { accessToken, setAccessToken, setOrgId } = useAuth((state) => ({
      accessToken: state.accessToken,
      setAccessToken: state.setAccessToken,
      setOrgId: state.setOrgId,
    }));

    const authData = useAuth((s) => s.userDetails);
    const mode = authData?.mode;
    const fetchUserDetails = useAuth((s) => s.fetchUserDetails);
    const orgId = authData?.memberInformation?.organisation?.organisationId;
    useEffect(() => {
      if (session?.accessToken && typeof session.accessToken === 'string') {
        setAccessToken(session.accessToken);
        setOrgId(router?.query?.orgId as string);
      }
    }, [session]);
    useEffect(() => {
      if (accessToken) {
        fetchUserDetails();
      }
    }, [accessToken]);

    useEffect(() => {
      if (session?.accessToken && authData?.authentication === 'userInfoPending') {
        AnalyticsInitialUserTracking(authData);
        Router.push(Navigation.SigningUserInfo.href);
      } else if (session?.accessToken && authData?.authentication === 'authorised') {
        AnalyticsUserTracking(authData);
        const selectedTemplate = localStorage.getItem('selectedTemplate');
        if (selectedTemplate?.length === 0 || selectedTemplate === null) {
          Router.push(`${mode}/${orgId}/dashboard`);
        } else {
          Router.push(`${mode}/${orgId}/templates/${selectedTemplate}`);
          localStorage.removeItem('selectedTemplate');
        }
      }
    }, [authData]);

    const AnalyticsInitialUserTracking = (data) => {
      Analytics.track('Signs In', { Status: 'Success' });
      Analytics.alias(data.userId);
      Analytics.people.set_once({
        $avatar: data.avatarUrl,
        $name: data.name,
        $email: data.email,
        $distinct_id: data.userId,
        $created: new Date().toLocaleString(),
      });
    };

    const AnalyticsUserTracking = (data) => {
      const getNumberOfMembersFromOrgs = (userData) => {
        return (
          userData.organisations?.reduce((acc, current) => acc + current?.members.length, 0) || 1
        );
      };

      Analytics.track('Signs In', { Status: 'Success' });
      Analytics.identify(data.userId);
      Analytics.people.set({
        $avatar: data.avatarUrl,
        $name: data.name,
        $email: data.email,
        $distinct_id: data.userId,
        'User Level': data.statistics?.target,
        Points: data.statistics?.points,
        '#members': getNumberOfMembersFromOrgs(data),
      });
    };

    if (!loading) return <Component />;

    return <FullPageLoader loading={true} />;
  };
  Wrapper.MetaData = Component.MetaData;
  return Wrapper;
};
